import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./ResponsiveImage.css";

// Import the lazyloading module if the window context is defined.
if(typeof window !== "undefined") {
  import("lazysizes");
}

const ResponsiveImage = ({ src, alt, lazyload, aspectRatio }) => {

  const paddingBottom = `${(1 / aspectRatio) * 100}%`;

  return (
    <div className={styles.root} style={{ paddingBottom }}>
      {lazyload ? (
        <img className={classNames(styles.image, "lazyload")} data-src={src} alt={alt} />
      ) : (
        <img className={styles.image} src={src} alt={alt} />
      )}
    </div>
  );
};

ResponsiveImage.defaultProps = {
  alt: "",
};

ResponsiveImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  aspectRatio: PropTypes.number.isRequired,
  lazyload: PropTypes.bool,
};

export default ResponsiveImage;
